/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Field } from 'formik';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/

import { CheckFormik } from './';

/**
 * Exports
*/

/**
 * 
 */
export function ValuedField({ formik, ...props }) {
  /** Formik **/
  
  const { isFormik } = CheckFormik(formik);

  /** States **/

  const [ pendingEvent, setPendingEvent ] = useState(null);
  const [ value, setValue ] = useState(props.value || '');

  /** Side-Effects **/

  useEffect(() => {
    handleUpdatedValue();
  }, [ isFormik ? formik.values[props.name] : value ]);

  useEffect(() => {
    if (!isFormik && props.value !== value) {
      setValue(props.value);
    }
  }, [ props.value ]);

  /** Event Handlers **/

  /**
   * 
   */
  const handleUpdatedValue = () => {
    if (pendingEvent) {
      if (props.onChange) {
        props.onChange(pendingEvent);
      }
      
      setPendingEvent(null);
    }
  };

  /**
   * 
   */
  const handleChange = (event) => {
    if (isFormik) {
      formik.handleChange(event);
    } else {
      setValue(
        props.beforeSetValue
          ? props.beforeSetValue(event.target.value)
          : event.target.value
      );
    }

    setPendingEvent({ ...event });
  };

  /**
   * 
   */
  const handleRenderChildren = (field, children) => {
    return React.Children.map(
      children, handleRenderChild.bind(this, field)
    );
  };
  
  /**
   * 
   */
  const handleRenderChild = (field, child) => {
    if (!child) {
      return null;
    }

    if (['input', 'select'].includes(child.type)) {
      return React.cloneElement(child, {
        ...field, onChange: handleChange
      });
    } else if (child.props && child.props.children) {
      return React.cloneElement(child, {
        ...child.props,
        children: handleRenderChildren(field, child.props.children),
      });
    }

    return child;
  };

  /** Renderers **/

  /**
   * 
   */
  const renderField = ({ field }) => {
    return handleRenderChildren(field, props.children);
  };

  /**
   * 
   */
  const renderFormik = () => {
    return (
      <Field name={ props.name }>
        { renderField }
      </Field>
    );
  };

  /**
   * 
   */
  const renderContent = () => {
    return isFormik
      ? renderFormik()
      : renderField({
          field: {
            name: props.name,
            value: value
          }
        })
    ;
  };

  /** Output **/

  return !props.container
    ? renderContent()
    : React.cloneElement(props.container, {
        className: CssClassName(props.containerClassName),
        children: renderContent()
      })
  ;
}

ValuedField.propTypes = {
  name: PropTypes.string.isRequired,
  containerClassName: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  formik: PropTypes.object
};